var extras = [];
window.extras = extras;

(function () {
    require('./devalVR/PluginDetect_DevalVR.js');
    require('./devalVR/detectDevalVR.js');

    PluginDetect.getVersion('.');   // set delimiter
    if (PluginDetect.getVersion('DevalVR') != null) {

        var productDetail = {pro_name: 'DevalVR', pro_ver: PluginDetect.getVersion('DevalVR')};
        extras.push(productDetail);
    }
})();

(function () {
    require('./QuickTime/PluginDetect_QuickTime.js');
    require('./QuickTime/detectQuickTime.js');

    PluginDetect.getVersion('.');
    if (PluginDetect.getVersion('QuickTime') != null) {
        var productDetail = {pro_name: 'QuickTime', pro_ver: PluginDetect.getVersion('QuickTime')};
        extras.push(productDetail);
    }
})();

(function () {
    require('./AdobeReader/PluginDetect_AdobeReader.js');
    require('./AdobeReader/detectAdobeReader.js');

    PluginDetect.getVersion('.');
    if (PluginDetect.getVersion('AdobeReader') != null) {
        var productDetail = {pro_name: 'AdobeReader', pro_ver: PluginDetect.getVersion('AdobeReader')};
        extras.push(productDetail);
    }
})();

(function () {
    require('./VLCplayer/PluginDetect_VLC.js');
    require('./VLCplayer/detectVLC.js');

    PluginDetect.getVersion('.');
    if (PluginDetect.getVersion('VLC') != null) {
        var productDetail = {pro_name: 'VlcMediaPlayer', pro_ver: PluginDetect.getVersion('VLC')};
        extras.push(productDetail);
    }
})();

(function () {
    require('./WindowsMediaPlayer/PluginDetect_WMP.js');
    require('./WindowsMediaPlayer/detectWMP.js');

    PluginDetect.getVersion('.');
    if (PluginDetect.getVersion('WindowsMediaPlayer') != null) {
        var productDetail = {pro_name: 'WindowsMediaPlayer', pro_ver: PluginDetect.getVersion('WindowsMediaPlayer')};
        extras.push(productDetail);
    }
})();

(function () {
    require('./Flash/PluginDetect_Flash.js');
    require('./Flash/detectFlash.js');

    if (PluginDetect.getVersion('Flash') != null) {
        var productDetail = {pro_name: 'flashplayer', pro_ver: PluginDetect.getVersion('Flash')};
        extras.push(productDetail);
    }

})();


(function () {
    require('./java/PluginDetect_Java.js');
    require('./java/VerifyApplet.js');
    require('./java/detectJava.js');

    if (navigator.javaEnabled()) {
        if (PluginDetect.getVersion('Java', ' js/getJavaInfo.jar') != null) {
            var productDetail = {pro_name: 'java', pro_ver: PluginDetect.getVersion('Java', ' js/getJavaInfo.jar')};
            extras.push(productDetail);
        }
    }

})();